// extracted by mini-css-extract-plugin
module.exports = {"root":"Helper_root__1ns4e","iconDiscount":"Helper_iconDiscount__zZ_hd","text":"Helper_text__1GdT1"};